import { render } from "./AppModal.vue?vue&type=template&id=53080e73&scoped=true"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"

import "./AppModal.vue?vue&type=style&index=0&id=53080e73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53080e73"]])

export default __exports__